import React, { useState } from 'react';
import emailjs from '@emailjs/browser';
import {
  Container,
  Header,
  Title,
  Subtitle,
  Section,
  SectionTitle,
  ContactForm,
  Input,
  TextArea,
  Button,
  FAQItem,
  FAQQuestion,
  FAQAnswer,
  ScreenshotGallery,
  ScreenshotPlaceholder,
  FeatureList,
  FeatureCard,
  Footer,
  Link,
  LogoImage
} from './SharedStyledComponents';

const BeestmodeSupportPage = () => {
  const [openFAQ, setOpenFAQ] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [isLoading, setIsLoading] = useState(false);

  const handleFAQToggle = (index) => {
    setOpenFAQ(openFAQ === index ? null : index);
  };

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.name || !formData.email || !formData.message) {
      alert('אנא מלא את כל השדות הנדרשים.');
      return;
    }

    setIsLoading(true);

    try {
      const templateParams = {
        from_name: formData.name,
        from_email: formData.email,
        from_phone: 'BEESTMODE', // Phone field not included in this form
        message: formData.message,
        to_email: 'haggaimagen87@gmail.com'
      };

      await emailjs.send(
        'service_w3pkjf6',      // Service ID
        'template_lwf20nq',     // Template ID
        templateParams,
        'Sgy1Do0paUmA8QyPR'     // Public key
      );

      alert(`תודה ${formData.name}! ההודעה נשלחה בהצלחה. נחזור אליך בקרוב.`);
      setFormData({ name: '', email: '', message: '' });
    } catch (error) {
      console.error('EmailJS Error:', error);
      alert('שגיאה בשליחת ההודעה. אנא נסה שוב או צור קשר טלפונית.');
    } finally {
      setIsLoading(false);
    }
  };

  const faqData = [
    {
      question: "איך אני מתחיל להשתמש באפליקציה?",
      answer: "לאחר הורדת האפליקציה, פתח אותה וצור חשבון חדש. עקוב אחר ההוראות שעל המסך להגדרת הפרופיל שלך."
    },
    {
      question: "האפליקציה לא עובדת - מה לעשות?",
      answer: "נסה לסגור את האפליקציה ולפתוח אותה מחדש. אם הבעיה נמשכת, אתה יכול לנסות למחוק ולהתקין מחדש את האפליקציה."
    },
    {
      question: "איך אני מעדכן את הפרטים שלי?",
      answer: "כנס להגדרות האפליקציה, בחר 'פרופיל' ושם תוכל לערוך את כל הפרטים האישיים שלך."
    },
    {
      question: "איך אני יכול לבטל את המנוי?",
      answer: "כנס להגדרות iPhone > iTunes & App Store > Apple ID > הצג Apple ID > מנויים, ובחר לבטל את המנוי."
    },
    {
      question: "האפליקציה תומכת באיזה גרסאות iOS?",
      answer: "האפליקציה תומכת ב-iOS 14.0 ומעלה. מומלץ לעדכן למערכת הפעלה העדכנית ביותר."
    }
  ];

  return (
    <Container>
      <Header>
        <LogoImage 
            src="/logo_shade_transparent.png" 
            alt="אפליקציית כושר"
          />
        <Title>Beestmode</Title>
        <Subtitle>בנה תוכניות מותאמות אישית עקוב אחר ביצועים וקבל תובנות מתקדמות</Subtitle>
        <Subtitle>עקוב אחר ביצועים וקבל תובנות מתקדמות</Subtitle>
        <Subtitle>תוצרת ישראל!</Subtitle>
      </Header>

      <Section>
        <SectionTitle>צור קשר</SectionTitle>
        <p>יש לך שאלות או בעיות? אנחנו כאן לעזור!</p>
        <p><strong>אימייל:</strong> haggaimagen87@gmail.com</p>
        <p><strong>זמני מענה:</strong> ראשון - חמישי, 9:00-17:00</p>
        
        <ContactForm onSubmit={handleSubmit}>
          <Input
            type="text"
            name="name"
            placeholder="שם מלא"
            value={formData.name}
            onChange={handleInputChange}
            disabled={isLoading}
            required
          />
          <Input
            type="email"
            name="email"
            placeholder="כתובת אימייל"
            value={formData.email}
            onChange={handleInputChange}
            disabled={isLoading}
            required
          />
          <TextArea
            name="message"
            placeholder="תאר את הבעיה או השאלה שלך..."
            value={formData.message}
            onChange={handleInputChange}
            disabled={isLoading}
            required
          />
          <Button type="submit" disabled={isLoading}>
            {isLoading ? 'שולח הודעה...' : 'שלח הודעה'}
          </Button>
        </ContactForm>
      </Section>

      <Section>
        <SectionTitle>שאלות נפוצות</SectionTitle>
        {faqData.map((item, index) => (
          <FAQItem key={index}>
            <FAQQuestion onClick={() => handleFAQToggle(index)}>
              {item.question} {openFAQ === index ? '−' : '+'}
            </FAQQuestion>
            {openFAQ === index && (
              <FAQAnswer>{item.answer}</FAQAnswer>
            )}
          </FAQItem>
        ))}
      </Section>

      <Section>
        <SectionTitle>צילומי מסך</SectionTitle>
        <ScreenshotGallery>
          <ScreenshotPlaceholder>צילום מסך 1</ScreenshotPlaceholder>
          <ScreenshotPlaceholder>צילום מסך 2</ScreenshotPlaceholder>
          <ScreenshotPlaceholder>צילום מסך 3</ScreenshotPlaceholder>
          <ScreenshotPlaceholder>צילום מסך 4</ScreenshotPlaceholder>
        </ScreenshotGallery>
      </Section>

      <Section>
        <SectionTitle>תכונות מרכזיות</SectionTitle>
        <FeatureList>
          <FeatureCard>
            <h3>תכונה 1</h3>
            <p>תיאור של התכונה הראשונה והיתרונות שלה למשתמש.</p>
          </FeatureCard>
          <FeatureCard>
            <h3>תכונה 2</h3>
            <p>תיאור של התכונה השנייה והיתרונות שלה למשתמש.</p>
          </FeatureCard>
          <FeatureCard>
            <h3>תכונה 3</h3>
            <p>תיאור של התכונה השלישית והיתרונות שלה למשתמש.</p>
          </FeatureCard>
          <FeatureCard>
            <h3>תכונה 4</h3>
            <p>תיאור של התכונה הרביעית והיתרונות שלה למשתמש.</p>
          </FeatureCard>
        </FeatureList>
      </Section>

      <Section>
        <SectionTitle>מידע נוסף</SectionTitle>
        <p><strong>גרסה נוכחית:</strong> 1.0.0</p>
        <p><strong>תאימות:</strong> iOS 14.0 ומעלה</p>
        <p><strong>גודל:</strong> 45.2 MB</p>
        <p><strong>עדכון אחרון:</strong> 15 יולי 2025</p>
      </Section>

      <Footer>
        <p>&copy; 2025 שם החברה. כל הזכויות שמורות.</p>
        <div>
          <Link href="#">מדיניות פרטיות</Link>
          <Link href="#">תנאי שימוש</Link>
          <Link href="#">הסכם רישיון</Link>
        </div>
      </Footer>
    </Container>
  );
};

export default BeestmodeSupportPage;